export { P as PageFooter } from '../../../chunks/component-Basfl_yu.js';
import 'react/jsx-runtime';
import '@sgcmpteltd/uikit-react';
import 'react';
import '../../../chunks/component-C84AhI26.js';
import '../../../chunks/style-inject.es-Bff-fD1R.js';
import '../../../chunks/configs-DLiFtVTn.js';
import '../../../chunks/component-Cyp-fmfD.js';
import '../../../chunks/component-CTx1FLa0.js';
import '../../../chunks/utils-DV-S0hIC.js';
import '../../../chunks/component-XmxTw2Ek.js';
import '../../../chunks/component-ihz8qk_j.js';
import '../../../chunks/component-UqVqSYlo.js';
import 'clsx';

const LINK_KEY_CONTACT_US = 'contactUs';
const LINK_KEY_CAREERS = 'careers';
const LINK_KEY_REPORT_ERROR = 'reportError';

const isLinkKey = (value) => (typeof value === 'string' && [
    LINK_KEY_CONTACT_US,
    LINK_KEY_CAREERS,
    LINK_KEY_REPORT_ERROR,
].includes(value));

export { LINK_KEY_CAREERS, LINK_KEY_CONTACT_US, LINK_KEY_REPORT_ERROR, isLinkKey };
//# sourceMappingURL=index.js.map
